import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly apiUrl = `${environment.apiUrl}/version`;

  constructor(private readonly http: HttpClient) {
  }

  /** Public (no login required) since the footer shows the backend version to every visitor. */
  get(): Observable<{ version: string; updateCheckIntervalMinutes: number }> {
    return this.http.get<{ version: string; updateCheckIntervalMinutes: number }>(this.apiUrl);
  }
}
